import { Inject, Options, Vue } from "vue-property-decorator";
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ErrorIndicator from "@/shared/components/error-indicator/error-indicator";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-admin-app/appInsights";
import store from "@/trust-admin-app/store";
import { EventEmitter } from "events";
import { orderBy } from "lodash";
import { ref } from "vue";
import AddEditDirectorModal from "./add-edit-director-modal/index.vue";
import moment from "moment";
import { IlpDirectorRequest, IlpDirectorView, PracticeView } from "@/shared/modules/typescript-trustapi-client/models";

@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
    AddEditDirectorModal,
  },
  mixins: [FormatDateTimeMixin]
})
export default class PracticePeopleDirectors extends Vue {
  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private searchKeyword = '';
  private showActiveOnly = false;
  private sortMethod = 'desc';
  private activeSortHeader = 0;

  private directors: IlpDirectorView[] = [];
  private directorsDisplay: any = [];

  private loadingContent = false;
  private errorLoadingContent = false;
  private loadingDataSet = false;
  private errorLoadingDataSet = false;

  private directorRequest: IlpDirectorRequest = {};
  private showAddEditModal = false;

  private tableHeadings = [
    { text: 'Name', value: 'name', sortable: true, sortMethod: 'asc' },
    { text: 'Position', value: 'position', sortable: true, sortMethod: 'acs' },
    { text: 'Commenced', value: 'commencedDate', sortable: true, sortMethod: 'asc' },
    { text: 'Terminated', value: 'terminatedDate', sortable: true, sortMethod: 'acs' },
    { text: '', value: '', sortable: false, sortMethod: 'acs' },
  ];

  // created() {
  //   this.getGetCategories();
  // }

  mounted() {
    this.loadTableData();
  }

  private loadTableData(loadStat?: boolean) {
    this.loadingContent = true;

    this.apiService.PeopleApi?.apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(this.selectedPractice.id, '', false)
      .then((res: any) => {
        this.directors = res.data.data ?? [];
        this.directorsDisplay = this.directors;
        for (let i = 0; i < this.directors.length; i++) {
          this.directorsDisplay[i].name = this.directors[i].firstName + ' ' + this.directors[i].lastName;
        }
        if (loadStat) this.$emit('loadStatData');
        this.sortTableColumn(0, true);
        this.loadingContent = false;

      })
      .catch((err: any) => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to get directory list: ' + err);
        this.ai.trackException('Error, Unable to get directory list: ' + err);
        this.loadingContent = false;
        this.errorLoadingContent = true;
      })

  }

  private sortTableColumn(index: number, sortable: boolean) {
    if (sortable) {
      if (this.tableHeadings[index].sortable) {
        this.activeSortHeader = index;
        this.sortMethod = this.sortMethod === 'desc' ? 'asc' : 'desc';
        this.tableHeadings[index].sortMethod = this.sortMethod;
        if (this.directors.length > 0) {
          const nameSorter = index == 1 ? (c: any) => c.name.toLowerCase() : [this.tableHeadings[index].value, (c: any) => c.name.toLowerCase()];
          const orderByResults = orderBy(
            this.directors,
            nameSorter,
            [this.sortMethod as any]
          );
          this.directorsDisplay = orderByResults;
        }
      }
    }
  }

  private applyFilter(data: any) {
    if (this.searchKeyword == '') return data;
    const _result = data.filter((d: any) => {
      return (d.name.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) >= 0);
    })
    return _result;
  }

  private isActive(i: IlpDirectorView): boolean {
    const _terminatedDate = i.terminatedDate ?? null;
    if (_terminatedDate) {
      return moment().diff(i.terminatedDate, 'days') <= 0;
    } else {
      return true;
    }
  }

  private addNew() {
    const today = new Date((new Date()).setHours(0, 0, 0, 0));
    this.directorRequest = {
      id: 0,
      practiceId: this.selectedPractice.id,
      firstName: '',
      lastName: '',
      position: '',
      commencedDate: ref(today),
      terminatedDate: null,
    }
    this.showAddEditModal = true;
  }

  private edit(s: IlpDirectorRequest) {
    // Clone this object
    this.directorRequest = { ...s };

    // Get status id
    // this.signatoryRequest.statusId = s.status['id'];
    // set the date format for date picker
    this.directorRequest.commencedDate = new Date(this.directorRequest.commencedDate);
    this.directorRequest.terminatedDate = this.directorRequest.terminatedDate !== null ? new Date(this.directorRequest.terminatedDate) : null;
    this.showAddEditModal = true;
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }
}

